module.exports = __webpack_public_path__ + "img/corridoio 4.47eaed70.jpeg";